import { AnimatePresence } from "framer-motion";
import WorkspaceSwitchingOverlay from "src/components/shared/WorkspaceSwitchingOverlay";
import React, { createContext, useState, useContext } from "react";

export const WorkspaceSwitchingContext = createContext();

export const WorkspaceSwitchingProvider = ({ children }) => {
  const [isWorkspaceSwitching, setIsWorkspaceSwitching] = useState(false);
  const [targetWorkspace, setTargetWorkspace] = useState(null);
  const [currentWorkspace, setCurrentWorkspace] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(false);

  const startSwitching = (target = null, current = null) => {
    setTargetWorkspace(target);
    setCurrentWorkspace(current);
    setIsInitialLoad(!target && !current);
    setIsWorkspaceSwitching(true);
  };

  const finishSwitching = () => {
    setIsWorkspaceSwitching(false);
    setTimeout(() => {
      setTargetWorkspace(null);
      setCurrentWorkspace(null);
      setIsInitialLoad(false);
    }, 400);
  };

  return (
    <WorkspaceSwitchingContext.Provider
      value={{
        isWorkspaceSwitching,
        targetWorkspace,
        currentWorkspace,
        isInitialLoad,
        startSwitching,
        finishSwitching,
        setCurrentWorkspace,
      }}>
      {children}

      <AnimatePresence>
        {isWorkspaceSwitching && (
          <WorkspaceSwitchingOverlay
            key="workspace-overlay"
            isVisible={true}
            currentWorkspace={currentWorkspace}
            targetWorkspace={targetWorkspace}
            isInitialLoad={isInitialLoad}
          />
        )}
      </AnimatePresence>
    </WorkspaceSwitchingContext.Provider>
  );
};

export const useWorkspaceSwitching = () => useContext(WorkspaceSwitchingContext);
